export default (state = {}, action) => {


    switch (action.type) {
        case 'ADD_GOOGLE_REVIEW':
            return { ...state, [action.meta.id]: action.payload };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/googleReviews_reducer.js